var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "ul",
        { staticClass: "nav nav-tabs cf-panel-tab-header cf-panel-lg" },
        [
          _c(
            "li",
            {
              class: { active: _vm.activeForm === "search" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.activeForm = "search"
                },
              },
            },
            [_c("a", { attrs: { href: "#form-search" } }, [_vm._v("Search")])]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              class: { active: _vm.activeForm === "explore" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.activeForm = "explore"
                },
              },
            },
            [_c("a", { attrs: { href: "#form-explore" } }, [_vm._v("Explore")])]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "tab-content cf-panel-tab-body cf-panel-lg clearfix",
          staticStyle: { "padding-top": "0" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              $event.stopPropagation()
              return _vm.submit.apply(null, arguments)
            },
            reset: function ($event) {
              $event.preventDefault()
              $event.stopPropagation()
              return _vm.reset.apply(null, arguments)
            },
          },
        },
        [
          _c("QueryFormSearch", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeForm === "search",
                expression: "activeForm === 'search'",
              },
            ],
            class: {
              "col-xs-12": true,
              "col-md-6": _vm.filtersVisible && !_vm.queryBuilderVisible,
            },
            attrs: { id: "form-search" },
          }),
          _vm._v(" "),
          _c("QueryFormExplore", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeForm === "explore",
                expression: "activeForm === 'explore'",
              },
            ],
            class: {
              "col-xs-12": true,
            },
            attrs: { id: "form-explore" },
          }),
          _vm._v(" "),
          _vm.filtersVisible
            ? _c(
                "div",
                {
                  class: {
                    "col-xs-12": true,
                    "visible-xs": true,
                    "visible-sm": true,
                    "visible-md":
                      _vm.queryBuilderVisible || _vm.activeForm === "explore",
                    "visible-lg":
                      _vm.queryBuilderVisible || _vm.activeForm === "explore",
                  },
                },
                [_c("hr")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("QueryFormFilters", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.filtersVisible,
                expression: "filtersVisible",
              },
            ],
            class: {
              "col-xs-12": true,
              "col-md-6":
                _vm.activeForm === "search" && !_vm.queryBuilderVisible,
              "col-md-9":
                _vm.activeForm === "explore" || _vm.queryBuilderVisible,
            },
            attrs: { id: "filtercontainer" },
          }),
          _vm._v(" "),
          _vm._m(0),
        ],
        1
      ),
      _vm._v(" "),
      _c("QueryFormSettings", { attrs: { id: "settings" } }),
      _vm._v(" "),
      _c("History", { attrs: { id: "history" } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-xs-12" }, [
      _c("hr"),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn btn-primary btn-lg", attrs: { type: "submit" } },
        [_vm._v("Search")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-default btn-lg",
          attrs: { type: "reset", title: "Start a new search" },
        },
        [_vm._v("Reset")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-lg btn-default",
          attrs: {
            type: "button",
            "data-toggle": "modal",
            "data-target": "#history",
          },
        },
        [_vm._v("History")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-lg btn-default",
          attrs: {
            type: "button",
            "data-toggle": "modal",
            "data-target": "#settings",
          },
        },
        [
          _c("span", {
            staticClass: "glyphicon glyphicon-cog",
            staticStyle: { "vertical-align": "text-top" },
          }),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }